<template>
  <div class="content Tabs">

     <b-tabs card>
          <!-- <div class="categories" v-if="isPlugin">
              <CategoryComponent  :lang="lang.PluginCategory"></CategoryComponent>

          </div> -->

          <b-tab v-if="source=='LibraryTable' || source == 'LibraryDetails'" :title="lang.tab_NewLibrary"  :title-link-class="textColors" :title-item-class="textColors" active >

            <DeriveLibraryFormComponent :lang="lang.DeriveLibraryForm"></DeriveLibraryFormComponent>

          </b-tab>

          

        </b-tabs>

  </div>

</template>
<script>


import { mapGetters } from 'vuex'
import DeriveLibraryFormComponent from '@/components/shared/DeriveLibraryFormComponent'
//import CategoryComponent from '@/components/shared/CategoryComponent'

export default {
  name: "Content",
  components: {
    DeriveLibraryFormComponent,
    
    
    //CategoryComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'isPlugin',
      
    ]),
    source(){

      return this.$route.query.source;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created () {


  },
  updated() {


  },
  watch: {

  }
}
</script>

<style scooped>
  #DeriveLibraryFormComponent{
    width: 60%;
  }

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
  .categories{
    margin-left: 5px;
    margin-right: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryDerive/Middle/Content/Content.vue